import { render, staticRenderFns } from "./ModalTask.vue?vue&type=template&id=06bf2f18&"
import script from "./ModalTask.vue?vue&type=script&lang=js&"
export * from "./ModalTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports